mainApp.directive('preventKey', function () {

return {
    restrict: 'A',
    scope:{
            shouldPrevent: '&',
        },
    link: function ($scope, element) {
        element.bind('keydown', function (e, inputs) {

            var code = e.keyCode || e.which;
            var val = element[0].value;

            var current = document.activeElement;
            if($scope.shouldPrevent({code: code, val: val})){
                e.preventDefault();
            }
        })
    }
  }
});